var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("line",{"x1":"17.35","y1":"0.85","x2":"0.82","y2":"17.39","key":0}),React.createElement("line",{"x1":"17.35","y1":"17.39","x2":"0.82","y2":"0.85","key":1})]));
}

IconClose.defaultProps = {"width":"18.22","height":"18.28","viewBox":"0 0 18.22 18.28"};

module.exports = IconClose;

IconClose.default = IconClose;
